import { HandledError } from 'fitbeat.models';
import { userAvatarConfig } from './UserAvatarConfig';

export interface IResizableImageBuffer {
    buffer: Buffer;
    dimensions: {width: number, height: number};
}

export class UserAvatarService {
    constructor(private userAvatarsDb: any,
                private fetch: any,
                private imageResizer?: (inputBuffer: IResizableImageBuffer) => Promise<Buffer>) {}

    public updateUserBase64Avatar = async (uid: string, base64AvatarImage: string): Promise<boolean> => {
        if (!this.imageResizer) {
            throw new Error(`no image resizer specified`);
        }
        const inputBuffer = Buffer.from(base64AvatarImage, 'base64');
        const buffer = await this.imageResizer({ buffer: inputBuffer, dimensions: userAvatarConfig.dimensions});
        try {
            const userAvatar = await this.userAvatarsDb.get(uid);
            await this.userAvatarsDb.putAttachment(uid, 'avatar.png', userAvatar._rev, buffer, 'image/png');
            return true;
        } catch (e) {
            if (this.erorrIsNotFound(e)) {
                await this.userAvatarsDb.putAttachment(uid, 'avatar.png', buffer , 'image/png');
                return true;
            }
            throw e;
        }
    }

    public getUserBase64Avatar = async (uid: string): Promise<string|undefined> => {
        try {
            const userAvatar = await this.userAvatarsDb.get(uid, {
                attachments: true,
            });
            const attachment: any = userAvatar._attachments ? userAvatar._attachments['avatar.png'] : null;
            return attachment ? attachment.data : '';
        } catch (e) {
            if (this.erorrIsNotFound(e)) {
                return undefined;
            }
            throw e;
        }
    }

    public async getUserAvatarStream(uid: string, expressResponseStream: any) {
        const {
            name,
            auth: {
                username,
                password,
            },
        } = this.userAvatarsDb.__opts;

        const response = await this.fetch(`${name}/${uid}/avatar.png`, {
           headers: {
            Authorization:
              'Basic ' + Buffer.from(username + ':' + password).toString('base64'),
           },
          });
        if (!response.body) {
            throw new HandledError('no avatar body found');
        }

        if (response.status !== 200) {
            throw new HandledError(`failed to load avatar for ${uid}`);
        }
        expressResponseStream.set({
        'ETag': response.headers.get('ETag'),
        'Cache-Control': response.headers.get('Cache-Control'),
        });
        response.body.pipe(expressResponseStream);
    }

    private erorrIsNotFound = (e: any): boolean => {
        return e.status === 404;
    }
}
